import React, { useState } from 'react';

import { Text } from 'app/shopify/theme';
import { Column, Row } from 'app/shopify/components/layout';

import { ToggleIconButton } from './ToggleIconButton';

export function ToggleIconButtonShowcase() {
  const [isSelected, setIsSelected] = useState(false);

  return (
    <Column gap="spacing.general.x4" padding="spacing.general.x4">
      <Text variant="bodySmall" color="text.secondary">
        Toggle Icon Button - etats selected/not-selected, ghost/primary, small/medium.
      </Text>

      <Row gap="spacing.general.x3">
        <ToggleIconButton
          selected={isSelected}
          type={isSelected ? 'primary' : 'ghost'}
          onPress={() => setIsSelected((prev) => !prev)}
        />
      </Row>

      <Row gap="spacing.general.x3">
        <ToggleIconButton type="ghost" size="small" />
        <ToggleIconButton type="ghost" state="hover" />
        <ToggleIconButton type="ghost" state="pressed" />
      </Row>

      <Row gap="spacing.general.x3">
        <ToggleIconButton selected type="primary" size="small" />
        <ToggleIconButton selected type="primary" state="hover" />
        <ToggleIconButton selected type="primary" state="pressed" />
      </Row>

      <Row gap="spacing.general.x3">
        <ToggleIconButton type="primary" inverted />
        <ToggleIconButton type="primary" size="small" inverted />
        <ToggleIconButton selected type="primary" inverted />
      </Row>
    </Column>
  );
}
